import React from "react";
import env from "env";
import utils from "utils";
//import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export function MetaImageSelector({ form, fieldName, data }) {
  const field = form.findControl(fieldName);
  //console.log(field, fieldName)

  React.useLayoutEffect(() => {
    const handleMessage = (e) => {
      //console.log(e);
      var action = e.data.action;
      var onSelection = e.data.onSelection;
      var data = e.data.data;

      if (action === "media-selected") {
        if (onSelection === "selectedMediaFiles") {
          selectedMediaFiles(data);
        }
      }
    };
    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
    // eslint-disable-next-line
  }, []);

  function openLibrary(e) {
    var url = env.cmsEndpoint + "/cms41helper/browse/selectmedia?onSelection=selectedMediaFiles&maxSelect=1";
    var w = window.innerWidth;
    var h = window.innerHeight;
    window.open(url, "cms_library", `toolbar=yes,scrollbars=yes,resizable=yes,top=${w * 0.05},left=${h * 0.05},width=${w * 0.9},height=${h * 0.9}`);
  }

  function selectedMediaFiles(items) {
    //const field = form.findControl(fieldName);
    if (!field) return;
    //console.log(items)
    let obj = items;
    field.value = field.value || '';
    if (obj.items.length > 0) {
      // field.value = {
      //   imageUrl: obj.items[0].WebPath,
      //   alt: obj.items[0].Alt
      // }
      field.value = obj.items[0].WebPath;
    }
    form.reset();
  }

  function remove(e) {
    //if (!window.confirm('Delete this??')) return;
    field.value = '';
    form.reset();
  }

  return (
    <div className="imageSelector">

      {
        field.value &&
        <ImageListItem
          image={field.value}
          onRemove={remove}
        />
      }

      <button type="button" className="btn btn-warning" onClick={(e) => openLibrary(e)}>
        Open Media Library
      </button>
    </div>
  );
}

function ImageListItem({ image, onRemove, alt }) {
  return (
    <>
      <div className="" style={{width : '100px'}}> 
        <img src={utils.site.resourcePath(image)} alt={alt} style={{width : '100%'}} />
      </div>
      <div className="" style={{marginBottom : '1rem', marginTop : '0.5rem'}}>
        <div className="remove">
          <button type="button" className="btn btn-secondary btn-sm" onClick={(e) => onRemove(e)}>
            Remove
          </button>
        </div>
      </div>
    </>
  );
}